import React from 'react';

const HowToPlayContentPT: React.FC = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <div className="bg-blue-50 p-4 rounded-2xl">
        <h3 className="font-bold text-blue-800 mb-2">🎯 O Objetivo</h3>
        <p>Adivinhe quem tem qual número observando como eles atuam!</p>
      </div>

      <div className="bg-green-50 p-4 rounded-2xl">
        <h3 className="font-bold text-green-800 mb-2">👥 Jogadores</h3>
        <p>Você precisa de 4-10 jogadores. Uma pessoa será o "adivinhador" e os outros receberão números secretos de 1-9.</p>
      </div>

      <div className="bg-orange-50 p-4 rounded-2xl">
        <h3 className="font-bold text-orange-800 mb-2">🎭 Como Jogar</h3>
        <div className="space-y-2 text-sm">
          <p><strong>1.</strong> O adivinhador lê uma situação em voz alta</p>
          <p><strong>2.</strong> Todos os outros representam sua reação baseada no seu número</p>
          <p><strong>3.</strong> Número 1 = muito calmo, Número 9 = totalmente louco!</p>
          <p><strong>4.</strong> O adivinhador observa e tenta descobrir quem tem qual número</p>
        </div>
      </div>

      <div className="bg-purple-50 p-4 rounded-2xl">
        <h3 className="font-bold text-purple-800 mb-2">🏆 Vitória</h3>
        <p>O adivinhador ganha pontos para cada palpite correto. Então outra pessoa se torna o novo adivinhador!</p>
      </div>

      <div className="bg-yellow-50 p-4 rounded-2xl">
        <h3 className="font-bold text-yellow-800 mb-2">💡 Exemplo</h3>
        <p className="text-sm"><strong>Situação:</strong> "Você vê uma aranha no seu quarto"</p>
        <p className="text-sm">• Número 1: Fique calmo, talvez ignore</p>
        <p className="text-sm">• Número 9: Grite e corra!</p>
      </div>
    </div>
  );
};

export default HowToPlayContentPT;